import { atom } from "recoil"

export const AtomCurrentBadge1Name = atom({
    key:'ATOMCURBADGENAME1',
    default:''
})
  